export default function ComingSoon() {
  return (
    <>
      <article id="coming-soon">
        <div className="container" style={{ textAlign: "center" }}>
          <h1>Coming Soon...</h1>
          <p>
            This site still under construction and will be available very soon.
            Thank you for your patience.
          </p>
        </div>
      </article>
    </>
  );
}
